import { render, staticRenderFns } from "./detailAccessDynamic.vue?vue&type=template&id=4100d15a&scoped=true&"
import script from "./detailAccessDynamic.vue?vue&type=script&lang=js&"
export * from "./detailAccessDynamic.vue?vue&type=script&lang=js&"
import style0 from "./detailAccessDynamic.vue?vue&type=style&index=0&id=4100d15a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4100d15a",
  null
  
)

export default component.exports